<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      {{ query.wmsName }}
    </p>
    <template slot="extra">
      <Button
        type="primary"
        icon="md-checkbox-outline"
        @click="action(1)"
        v-access="'inventory.edit'"
        >保存调整</Button
      >
      <Button
        type="primary"
        icon="md-sync"
        @click="action(2)"
        v-access="'inventory.reset'"
        >刷新</Button
      >
      <Button type="primary" icon="ios-undo" @click="action(3)">返回</Button>
    </template>
    <Table
      :style="{ marginTop: '10px' }"
      border
      stripe
      :loading="loading"
      :columns="columns"
      :data="tbList"
    >
      <template slot-scope="{ row, index }" slot="sort">
        <span v-show="false">{{ row.code }}</span>
        {{ index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="action">
        <InputNumber
          :max="999999999"
          :min="0"
          :value="row.sub"
          placeholder="请输入"
          @on-change="(e) => calculation(e, row)"
        ></InputNumber>
      </template>
      <template slot-scope="{ row }" slot="status">
        <div style="margin: 0 auto; text-align: center">
          <Button type="success" size="small" v-if="row.status == '02'"
            >已上架</Button
          >
          <Button type="default" size="small" v-if="row.status == '03'"
            >已下架</Button
          >
        </div>
      </template>
      <template slot-scope="{ row }" slot="history">
        <Button
          icon="md-repeat"
          size="small"
          type="default"
          @click="logHandler(row)"
          v-access="'inventory.details'"
          >修改记录</Button
        >
      </template>
    </Table>
    <Page
      :total="total"
      :page-size="pageSize"
      :current="page"
      show-sizer
      show-total
      prev-text="上一页"
      next-text="下一页"
      @on-change="pageChange"
      @on-page-size-change="pageSizeChange"
      class="public-page"
    />
  </Card>
</template>
<script>
const columns = [
  {
    title: "序号",
    slot: "sort",
    width: 60,
  },
  {
    title: "商品名称",
    key: "skuName",
  },
  {
    title: "简称",
    key: "erpCode",
  },
  {
    title: "仓库",
    key: "wmsName",
  },
  {
    title: "三方仓库编码",
    key: "thirdPartyCode",
  },
  {
    title: "省份",
    key: "provinceAreaName",
  },
  {
    // title: 'GRADE GROUP',
    title: "渠道",
    key: "gradeGroup",
  },
  {
    title: "达能系统商品编码",
    key: "prdCode",
  },
  {
    title: "资金商商品编码",
    key: "spErpCode",
  },
  {
    title: "现有库存",
    key: "skuNum",
  },
  {
    title: "盘点库存",
    slot: "action",
    width: 120,
  },
  {
    title: "损益数量",
    key: "sum",
  },
  //   {
  //     title: '状态',
  //     slot: 'status',
  //     width: 100
  //   },
  {
    title: "修改记录",
    slot: "history",
    width: 120,
  },
];
export default {
  data() {
    return {
      query: {
        shipToCode: "",
        wmsCode: "",
      },
      pageSize: 10,
      page: 1,
      total: 0,

      wmsCode: "",
      shipToCode: "",
      columns,
      tbList: [],
      loading: false,
    };
  },
  created() {
    this.query = this.$route.query;
    this.$nextTick(() => {
      this.getList();
    });
  },
  methods: {
    getList() {
      let data = {
        wmsCode: this.query.wmsCode,
        shipToCode: this.query.shipToCode,
        pageSize: this.pageSize,
        page: this.page,
      };
      this.loading = true;
      this.$api["queryInvList"](data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data.map((item) => {
            item.sub = null;
            return item;
          });
          this.total = res.total;
        }
      });
    },
    calculation(e, r) {
      this.tbList = this.tbList.map((item, i) => {
        if (item.id == r.id) {
          item.sub = e;
          item.sum = e == null ? null : e - item.skuNum;
        }
        return item;
      });
    },
    action(t) {
      switch (t) {
        case 1:
          this.saveList();
          break;
        case 2:
          this.page = 1;
          this.pageSize = 10;
          this.$nextTick(() => {
            this.getList();
          });
          break;
        default:
          this.$router.replace({ path: "/inventory" });
      }
    },
    saveList() {
      let data = [];
      this.tbList.forEach((item) => {
        if (item.sub || item.sun == 0) {
          data.push({
            id: item.id,
            skuNum: item.sub,
          });
        }
      });
      this.$api["updateInv"](data).then((res) => {
        if (res.code == "200") {
          this.$Message.success("保存成功");
          this.getList();
        }
      });
    },
    toggleStatus(type, row) {
      if (type == 0) {
        this.$store
          .dispatch("warehouse/wmsInvDisable", { id: row.id })
          .then((res) => {
            if (res.code == "200") {
              this.$Message.success("下架成功");
              this.getList();
            } else {
              this.$Message.error(res.msg || "下架失败");
            }
          });
      } else {
        this.$store
          .dispatch("warehouse/wmsInvEnable", { id: row.id })
          .then((res) => {
            if (res.code == "200") {
              this.$Message.success("上架成功");
              this.getList();
            } else {
              this.$Message.error(res.msg || "上架失败");
            }
          });
      }
    },
    logHandler(row) {
      this.$router.push({
        path: "/inventoryLogByProduct",
        query: {
          skuCode: row.skuCode || "",
          skuName: row.skuName || "",
          spCode: row.spCode || "",
          gradeGroup: row.gradeGroup || "",
          wmsCode: row.wmsCode || "",
          areaCode: row.provinceAreaCode || "",
          wmsName: row.wmsName || "",
          shipToCode: row.shipToCode || "",
          is_diff: 1,
        },
      });
    },
    // 页码
    pageChange(d) {
      this.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.pageSize = d;
      this.getList();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/warehouse/inventoryEdit.vue